import { Button, Input, Modal, Overlay, Progress } from "@mantine/core";

import { useGetDarkMode } from "_common/hooks/global";
import { getOptImage }    from "_common/utils";
import { PrimaryButton }  from "_components/atoms/button";
import Icon               from "_components/atoms/icon";
import Image              from "_components/atoms/image";
import Typography         from "_components/atoms/typography";
import useStyles          from "_styles/molecules/userOnboarding";

const component = ( {
	step,
	languages,
	name,
	setName,
	validName,
	handleClickNext,
	handleLanguageSelection,
	locale,
	handleClickBack,
	games,
	handleGameSelection,
	selectedGames,
	fromUserSettings,
	handleClickDone,
	handleClickCancel,
	handleClickDownload,
	handleKeyPress
} ) => {

	const { classes } = useStyles ( { name, validName, locale, step, selectedGames, fromUserSettings }, { name: "userOnboarding" } );
	const darkMode    = useGetDarkMode ();

	return (
		<Modal
			centered
			classNames      = { {
				content : classes.customDialog,
				body    : classes.modalBody
			} }
			closeOnEscape   = { true }
			id              = "onboard"
			onKeyDown       = { handleKeyPress }
			opened          = { true }
			styles          = { {
				root: {
					justifyContent : fromUserSettings ? "right" : "center",
					alignItems     : fromUserSettings ? "flex-start" : "center"
				},
				body: {
					// height: "50vh"
					maxHeight: "50vh"
				}
			} }
			withCloseButton = { false }
			zIndex          = { 1202 }
		>
			<InnerComponent
				darkMode                = { darkMode }
				fromUserSettings        = { fromUserSettings }
				games                   = { games }
				getOptImage             = { getOptImage }
				handleClickBack         = { handleClickBack }
				handleClickCancel       = { handleClickCancel }
				handleClickDone         = { handleClickDone }
				handleClickDownload     = { handleClickDownload }
				handleClickNext         = { handleClickNext }
				handleGameSelection     = { handleGameSelection }
				handleLanguageSelection = { handleLanguageSelection }
				languages               = { languages }
				locale                  = { locale }
				name                    = { name }
				selectedGames           = { selectedGames }
				setName                 = { setName }
				step                    = { step }
				validName               = { validName }
			/>

		</Modal>
	);
};

export default component;

function InnerComponent ( {
	fromUserSettings,
	step,
	darkMode,
	handleClickCancel,
	setName,
	name,
	games,
	handleLanguageSelection,
	locale,
	handleGameSelection,
	getOptImage,
	handleClickBack,
	handleClickNext,
	languages,
	validName,
	handleClickDownload,
	handleClickDone,
	selectedGames
} ) {
	const { classes } = useStyles ( { name, validName, locale, step, selectedGames, fromUserSettings }, { name: "userOnboarding" } );

	return (
		<>

			<div className = { classes.topHeader }>
				<Typography className = { classes.settingsText }
					title                = { !fromUserSettings ? "Update Profile & Win 200 Coins" : fromUserSettings && step === 2 ? "Which language videos do you prefer?" : fromUserSettings && step === 3 ? "Select your most favorite games" : null }
				/>

				<Icon sameInBothTheme
					className = { darkMode ? classes.crossButtonInvert : classes.crossButton }
					name      = "seachBarCross"
					onClick   = { handleClickCancel }
				/>

			</div>

			<div className = { classes.modalContent }>
				{step === 1 && (
					<div className = { classes.contentContainer }
						style         = { {
							maxWidth : "590px",
							padding  : "20px 24px"
						} }
					>
						<div className = { classes.progressContainer }>
							<Progress h = { "0.8rem" }
								radius     = { "xl" }
								value      = { 0 }
								w          = { "100%" }
							/>

							<Typography className = { classes.coinsContainer }
								title                = "200"
							/>

							<Icon sameInBothTheme
								className = { classes.coinsSvg }
								name      = "coinsIcon"
							>
							</Icon>

						</div>

						<Typography className = { classes.nameText }
							title                = "Name"
						/>

						<Input // fullWidth
							autoFocus
							autoComplete = "off"
							classNames   = { {
								root  : classes.root,
								input : classes.label
							} }
							id           = "searchInput"
							label        = ""
							onChange     = { e => setName ( e.target.value ) }
							placeholder  = { "Enter your name" }
							radius       = { "lg" }
							size         = "xl"
							value        = { name }
						/>

					</div>
				)}

				{step === 2 && (
					<div className = { classes.contentContainer }
						style         = { {
							maxWidth : "590px",
							padding  : "20px 24px"
						} }
					>
						{!fromUserSettings && (
							<div className = { classes.progressContainer }>
								<Progress h = { "0.8rem" }
									radius     = { "xl" }
									value      = { 33 }
									w          = { "100%" }
								/>

								<Typography className = { classes.coinsContainer }
									title                = "200"
								/>

								<Icon sameInBothTheme
									className = { classes.coinsSvg }
									name      = "coinsIcon"
								>
								</Icon>

							</div>
						)}

						{!fromUserSettings && (
							<Typography className = { classes.nameText }
								title                = "Which language videos do you prefer?"
							/>
						)}

						<div className = { classes.languageGrid }>
							{languages.map ( ( language, idx ) => {
								return (
									<div key = { idx }
										onClick = { () => handleLanguageSelection ( language.locale ) }
										style   = { {
											position : "relative",
											margin   : "0.7rem 1rem 0.7rem 0rem",
											cursor   : "pointer"
										} }
									>
										<Image className = { classes.languageImage }
											src             = { language.image }
											type            = "mdpi"
										/>

										<p style = { {
											position   : "absolute",
											top        : "8px",
											left       : "10px",
											color      : "white",
											fontWeight : "500",
											fontSize   : "1.2rem"
										} }
										>
											{language.name}

											<br></br>

											{" "}
											Videos
										</p>

										{( locale === language.locale || locale === language.name ) && <div className = { classes.overlayLanguage }></div>}

									</div>
								);
							} )}
						</div>

					</div>
				)}

				{step === 3 && (
					<div className = { classes.contentContainer }
						style         = { {
							maxWidth : "590px",
							padding  : "20px 24px"
						} }
					>
						<div>
							{!fromUserSettings && (
								<div className = { classes.progressContainer }>
									<Progress h = { "0.8rem" }
										radius     = { "xl" }
										value      = { 66 }
										w          = { "100%" }
									/>

									<Typography className = { classes.coinsContainer }
										title                = "200"
									/>

									<Icon sameInBothTheme
										className = { classes.coinsSvg }
										name      = "coinsIcon"
									>
									</Icon>

								</div>
							)}

							{!fromUserSettings && (
								<Typography className = { classes.nameText }
									title                = "Select your most favorite games:"
								/>
							)}

							<div className = { classes.gridContainer }>
								{games.map ( ( game, idx ) => {
									return (
										<div key = { idx }
											onClick = { () => handleGameSelection ( game.id, game.name ) }
											style   = { {
												cursor: "pointer"
											} }
										>
											<div style = { { position: "relative", aspectRatio: "1", width: "10rem", borderRadius: "1rem", overflow: "hidden" } }>
												<Image
													src = { game.image }
												/>

												{selectedGames.includes ( game.id ) && (
													<Overlay color = "#126bd5"
														opacity       = { 0.5 }
													>
														<div className = { classes.selectedGame }>
															{selectedGames.indexOf ( game.id ) + 1}

														</div>

													</Overlay>
												)}
											</div>

											<Typography
												truncate
												size   = "sm"
												ta     = "center"
												title  = { game.name }
												w      = "10rem"
												weight = "500"
											>
											</Typography>

										</div>

									);
								} )}
							</div>
						</div>

					</div>
				)}

				{step === 4 && (
					<div className = { classes.contentContainer }
						style         = { {
							maxWidth : "590px",
							padding  : "20px 24px"
						} }
					>
						<div className = { classes.progressContainer }>
							<Progress h = { "0.8rem" }
								radius     = { "xl" }
								value      = { 100 }
								w          = { "100%" }
							/>

							<Typography className = { classes.coinsContainer }
								title                = "200"
							/>

							<Icon sameInBothTheme
								className = { classes.coinsSvg }
								name      = "coinsIcon"
							>
							</Icon>

						</div>

						<div className = { classes.completeOnboardContainer }>

							<Icon sameInBothTheme
								className = { classes.completedIcon }
								name      = "onboardingComplete"
							>
							</Icon>

							<Typography className = "fontBold topSpacing bottomSpacing"
								title                = "Profile Updated Successfully, you won:"
								variant              = "h4"
							/>

							<div className = { classes.completedCoinsContainer }>

								<Icon sameInBothTheme
									className = { classes.completedCoins }
									name      = "coinsIcon"
								>
								</Icon>

								<Typography className = { "fontBold" }
									title                = "200"
									variant              = "h3"
								/>

								{" "}

							</div>

							<div className = { classes.informationContainer }>

								<Icon sameInBothTheme
									className = { classes.infoIcon }
									name      = "greyInfoIcon"
								>
								</Icon>

								<Typography color = "secondary"
									title            = "You can redeem the coins for amazing rewards in our mobile app."
									variant          = "h6"
								/>
							</div>
						</div>

					</div>
				)}
			</div>

			{!fromUserSettings ? (
				<div className = { classes.bottomSection }>
					{step !== 4 && (
						<Typography className = "fontBold"
							title                = { `Step ${ step } of 3` }
						/>
					)}

					<div>
						{step > 1 && step !== 4 ? (
							<Button className = { classes.backButton }
								onClick          = { handleClickBack }
							>
								Back

							</Button>
						) : step === 4 ? (
							<Button className = { classes.backButton }
								onClick          = { handleClickCancel }
							>
								Close

							</Button>
						) : null}

						{step < 3 ? (
							<PrimaryButton disabled = { step === 1 && !name || name && name.trim ().length === 0 || step === 2 && !locale || step === 3 && selectedGames.length === 0 ? true : false }
								onClick                = { handleClickNext }
								title                  = "Next"
							/>
						) : step === 3 ? (
							<PrimaryButton disabled = { step === 1 && !name && validName || step === 2 && !locale || step === 3 && selectedGames.length === 0 ? true : false }
								onClick                = { handleClickNext }
								title                  = { `DONE ${ selectedGames.length } / 3` }
							/>
						) : (
							<PrimaryButton onClick = { handleClickDownload }
								title                 = { "Download App" }
							/>
						)}
					</div>

				</div>
			) : (
				<div className = { classes.bottomSection }>
					<PrimaryButton buttonTextClassName = { classes.btnLabel }
						className                         = { classes.btn }
						disabled                          = { step === 1 && !name && validName || step === 2 && !locale || step === 3 && selectedGames.length === 0 ? true : false }
						onClick                           = { handleClickDone }
						title                             = { `DONE ${ step === 3 ? selectedGames.length + "/ 3" : "" }` }
					/>

				</div>
			)}
		</>
	);
}
